export default __webpack_public_path__ + "static/media/NFT_Icon.3971ff10.png";